import { render, staticRenderFns } from "./SurveyModal.vue?vue&type=template&id=2262e7b4&scoped=true&"
import script from "./SurveyModal.vue?vue&type=script&lang=ts&"
export * from "./SurveyModal.vue?vue&type=script&lang=ts&"
import style0 from "./SurveyModal.vue?vue&type=style&index=0&id=2262e7b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2262e7b4",
  null
  
)

export default component.exports